import { mapActions } from 'vuex';
import { ACCOUNT, ACCOUNT_CHECKOUT } from '@/stores/defs';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
import CustomerModel from '../../models/CustomerModel';
import PaymentAccountModel from '../../models/PaymentAccountModel';

export default {
	methods: {
		...mapActions({
			setCustomer: ACCOUNT.SET_CUSTOMER,
			setPaymentMethod: ACCOUNT_CHECKOUT.SET_PAYMENT_METHOD,
			setLoggedIn: ACCOUNT.SET_LOGGED_IN,
		}),
		logout(useRoute) {
			const customer = new CustomerModel({
				id: '',
			});
			this.setCustomer(customer);
			const paymentAccountModel = new PaymentAccountModel({
				id: '',
				accountNumber: '',
			});
			this.setPaymentMethod(paymentAccountModel);
			this.setLoggedIn(false);
			localStorageAdapter.setCustomerBase('');
			localStorageAdapter.setItem('customer', customer);
			if (useRoute) {
				this.$router.push({ path: useRoute });
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/mixins/logoutMixin.js